export enum FormsKeys {
  // Some keys carry a -v2 suffix because the persisted shape changed and the old one restores
  // wrong rather than failing: gebaeudedaten renamed step5/step6 keys (gesamtflaecheKeller,
  // aussenwandBauweise) and silently handed back Bauweise.Massiv for someone who answered Holz;
  // versicherungsdaten moved step9/step10 onto the generated types, where the stored '250' is no
  // longer a HausratSelbstbeteiligung at all.
  vertragsdaten = 'vertragsdaten',
  gebaeudedaten = 'gebaeudedaten-v2',
  zurPerson = 'zur-person',
  versicherungsdaten = 'versicherungsdaten-v2',
  schutzOptimieren = 'schutz-optimieren',
  calculator = 'calculator',
}
